export enum BikyUserEnum {
  Name = 'Biky',
  LastName = 'Montes',
  Email = 'bikymontes@keybe.ai'
}
